module.exports = __webpack_public_path__ + "static/img/head-es.813e91c0.png";